// Pure pagination math for the list views (backend returns total/limit/offset).

export function pageMeta({ total = 0, limit = 100, offset = 0 } = {}) {
  const safeLimit = Math.max(1, Number(limit) || 1);
  const safeOffset = Math.max(0, Number(offset) || 0);
  const safeTotal = Math.max(0, Number(total) || 0);
  const page = Math.floor(safeOffset / safeLimit) + 1;
  const pageCount = Math.max(1, Math.ceil(safeTotal / safeLimit));
  const from = safeTotal === 0 ? 0 : safeOffset + 1;
  const to = Math.min(safeOffset + safeLimit, safeTotal);
  return {
    page,
    pageCount,
    from,
    to,
    total: safeTotal,
    hasPrev: safeOffset > 0,
    hasNext: safeOffset + safeLimit < safeTotal,
  };
}
